var map = {
	"./noble01/等级勋章@2x.png": "4848",
	"./noble02/等级勋章@2x.png": "1475",
	"./noble03/等级勋章@2x.png": "bf8e",
	"./noble04/等级勋章@2x.png": "74c8",
	"./noble05/等级勋章@2x.png": "3956"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5726";